export default __webpack_public_path__ + "static/media/p8.1bd683b3.jpeg";